// extracted by mini-css-extract-plugin
export default {"notification":"L5n42pyUH4NGwY69MYu2","error":"RXZ2Nq4nTuqfDp7kAnwf","success":"hfhPqQM0jBFVBdVlhFXo","notificationClear":"tCDGLnvoeyjBGeg0UISq"};